export function waAuthHeaders(extra: Record<string, string> = {}): Record<string, string> {
  const token = localStorage.getItem('accessToken');
  return { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...extra };
}
